import { createAboutFlight } from "./about-flight.js";

const dialog = document.querySelector("#about");
const trigger = document.querySelector('a[href="#about"]');
const app = document.querySelector(".app");
const backgroundPanels = document.querySelectorAll(".app__widget, .app__info");
let isOpen = false;
let flight;
const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
const typewriter = dialog.querySelector(".about__typewriter span");
const words = ["Design.", "Build.", "Refine."];
let typingTimer;

// A small triangulated sphere, projected into SVG with dimmer rear edges.
const sphere = dialog.querySelector(".about-tile__sphere");
const vertices = [
  [0, -1, 0],
  [0, 1, 0],
];
const edges = [];
for (let ring = 0; ring < 3; ring++) {
  const latitude = ((ring + 1) * Math.PI) / 4;
  for (let segment = 0; segment < 8; segment++) {
    const longitude = (segment * Math.PI) / 4 + (ring * Math.PI) / 8;
    vertices.push([
      Math.sin(latitude) * Math.cos(longitude),
      -Math.cos(latitude),
      Math.sin(latitude) * Math.sin(longitude),
    ]);
    const index = 2 + ring * 8 + segment;
    edges.push([index, 2 + ring * 8 + ((segment + 1) % 8)]);
    if (ring === 0) edges.push([0, index]);
    if (ring === 2) edges.push([1, index]);
    if (ring < 2) edges.push([index, index + 8], [index, 2 + (ring + 1) * 8 + ((segment + 7) % 8)]);
  }
}
const sphereLines = edges.map(() => {
  const line = document.createElementNS("http://www.w3.org/2000/svg", "path");
  sphere.append(line);
  return line;
});
let sphereFrame;

function drawSphere(time = 0) {
  const angle = time / 7000;
  const points = vertices.map(([x, y, z]) => {
    const rx = x * Math.cos(angle) + z * Math.sin(angle);
    const rz = z * Math.cos(angle) - x * Math.sin(angle);
    return [
      60 + 51 * (rx * Math.cos(0.25) - y * Math.sin(0.25)),
      60 + 51 * (rx * Math.sin(0.25) + y * Math.cos(0.25)),
      rz,
    ];
  });
  edges.forEach(([a, b], index) => {
    sphereLines[index].setAttribute("d", `M${points[a][0]},${points[a][1]}L${points[b][0]},${points[b][1]}`);
    sphereLines[index].setAttribute("opacity", 0.2 + (0.8 * ((points[a][2] + points[b][2]) / 2 + 1)) / 2);
  });
  if (isOpen && !reducedMotion.matches && !document.hidden) sphereFrame = requestAnimationFrame(drawSphere);
}

function syncSphere() {
  cancelAnimationFrame(sphereFrame);
  drawSphere();
}

reducedMotion.addEventListener("change", syncSphere);
document.addEventListener("visibilitychange", syncSphere);

function syncTypewriter() {
  clearTimeout(typingTimer);
  if (!isOpen) return;
  typewriter.textContent = words[0];
  if (reducedMotion.matches || document.hidden) return;
  let wordIndex = 0;
  let frame = 0;
  let deleting = false;
  const symbols = "#<>/01_";

  function tick() {
    const word = words[wordIndex];
    let delay = 45;
    if (deleting) {
      typewriter.textContent = typewriter.textContent.slice(0, -1);
      if (!typewriter.textContent) {
        deleting = false;
        frame = 0;
        wordIndex = (wordIndex + 1) % words.length;
        delay = 300;
      }
    } else {
      const length = Math.floor(frame / 3);
      typewriter.textContent = word.slice(0, length);
      if (length < word.length) {
        typewriter.textContent += symbols[Math.floor(Math.random() * symbols.length)];
        frame++;
      } else {
        deleting = true;
        delay = 1500;
      }
    }
    typingTimer = setTimeout(tick, delay);
  }

  typewriter.textContent = "";
  typingTimer = setTimeout(tick, 500);
}

reducedMotion.addEventListener("change", syncTypewriter);
document.addEventListener("visibilitychange", syncTypewriter);
dialog.dataset.surface =
  document.querySelector(".app__logo").getAttribute("aria-pressed") === "true" ? "fuchsia" : "white";
document.documentElement.addEventListener("themechange", ({ detail }) => {
  dialog.dataset.surface = detail.white ? "fuchsia" : "white";
});

function syncAbout() {
  const open = location.hash === "#about";
  if (open === isOpen) return;
  isOpen = open;
  syncTypewriter();
  syncSphere();
  if (open) {
    app.classList.add("app--about-open");
    backgroundPanels.forEach((panel) => {
      panel.inert = true;
    });
  }
  dialog.inert = !open;
  trigger.setAttribute("aria-expanded", String(open));
  if (open) {
    dialog.hidden = false;
    dialog.dataset.open = "true";
    if (!flight && !reducedMotion.matches) flight = createAboutFlight(dialog, hideAbout);
    flight?.timeline.timeScale(1).play();
    dialog.querySelector(".about__close").focus({ preventScroll: true });
  } else if (flight && flight.timeline.time() > 0) {
    flight.timeline.timeScale(1.6).reverse();
  } else {
    hideAbout();
  }
}

function hideAbout() {
  dialog.hidden = true;
  dialog.dataset.open = "false";
  flight?.release();
  flight = undefined;
  app.classList.remove("app--about-open");
  backgroundPanels.forEach((panel) => {
    panel.inert = false;
  });
  trigger.focus({ preventScroll: true });
}

trigger.addEventListener("click", (event) => {
  event.preventDefault();
  if (isOpen) return;
  history.pushState({ ...history.state, aboutModal: true }, "", "#about");
  // Other hash-driven controls (the playground) should follow the same navigation.
  window.dispatchEvent(new HashChangeEvent("hashchange"));
});

function closeAbout() {
  if (!isOpen) return;
  if (history.state?.aboutModal) history.back();
  else {
    history.replaceState(history.state, "", location.pathname + location.search);
    syncAbout();
  }
}

dialog.querySelector(".about__close").addEventListener("click", closeAbout);
window.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && !dialog.hidden) {
    event.preventDefault();
    closeAbout();
  }
});
window.addEventListener("hashchange", syncAbout);
window.addEventListener("popstate", syncAbout);
syncAbout();

// Settle and release the flight if reduced motion is enabled mid-animation.
reducedMotion.addEventListener("change", () => {
  if (!reducedMotion.matches || !flight) return;
  if (!isOpen) return hideAbout();
  flight.timeline.progress(1);
  flight.release();
  flight = undefined;
});
